module.exports = __webpack_public_path__ + "static/media/prajakta_ghatage.8adb3575.jpeg";